import { Model } from 'modules/core/lib/mobx-rest'

interface IResult {
  [key: string]: any
}

class Result extends Model<IResult> {
  constructor(attr: IResult = {}) {
    super(attr)
  }

  static urlRoot() {
    return '/payroll/results'
  }
}

export default Result
